<template>
  <div>
    <!-- Logo/Mobile Menu Button -->
    <div class="flex items-center gap-4">
      <LogoIcon class="h-8 w-auto text-white z-1000 shrink-0 " style="cursor:default" @click="router.push('/portal/certificates')"/>
    </div>
    
    <div class="no-print main-container bg-[]  fixed left-0 top-0 shadow z-50 w-full h-12 justify-right">
      <div class="flex-1"></div>
      <div class="flex justify-center">
        <div class="flex items-center gap-1  mr-2">
          
          <UDropdownMenu  v-model:open="open" :modal="false" class='pseudo-navbar-option userNavMenuButton' style="cursor:pointer"
            @mouseenter="open = true"
            @mouseleave="open = false"
            :items="(userMenu as any)"
            :ui="{
              content: 'w-48'
            }"
          >
            <button @click="logout" color="neutral" variant="outline" class="pseudo-navbar-overflown-options-button flex items-center">
              <UIcon name="i-lucide-dot" class="text-green-500 ml-0" />
              <UIcon name="i-lucide-user-circle" /> &nbsp;
              {{ nombreUsuario }} &nbsp;
              <UIcon name="i-lucide-log-out" /> 
            </button> 
          </UDropdownMenu>
          <!-- <button v-if="isTouchDevice" @click="toggleFullscreen" class="no-print fullscreen-button items-left" >
            <UIcon name="i-lucide-expand" style="margin-bottom:-1px" title=""/>
          </button> -->
        </div>
      </div>
    </div>
    <div v-if="isMobileMenuOpen" class="fixed inset-0 backdrop-blur-xs md:backdrop-filter-none lg:backdrop-filter-none bg-opacity-50 z-40 " @click="toggleMobileMenu"></div>
    
    <div v-if="isMobileMenuOpen" class="fixed top-0 left-0 h-full w-full max-w-[375px] xs:w-32 sm:w-72 md:w-72 shadow-lg z-50 transform transition-transform flex flex-col"
      :style="menuStyle == '1' ? '-webkit-backdrop-filter: blur(10px); backdrop-filter: blur(8px); background: linear-gradient(147.04deg, rgb(0 75 119 / 80%) 0.74%, #17185f 99.61%)':
      'backdrop-filter: blur(8px); background: linear-gradient(147.04deg, rgb(0 0 0 / 32%) 0.74%, rgba(38, 39, 114, 0.26) 99.61%)'">
      <div class="p-2 flex justify-end " :title="$t('common.sidebar.close_sidebar')">
          <button class="bg-3a-nav-btn" @click="toggleMobileMenu"  style="cursor:pointer">
              <X class="h-4 w-4" />
          </button>
      </div>
      <div class="px-4 pt-2 flex items-start pb-2 flex-shrink-0">
        <span class="text-white font-medium">
        {{ nombreUsuario }} <br />
        <small class="text-white/80">{{ email }}</small>
        </span>
      </div>
      <!-- Body (scrollable menu) -->
      <div class="menux px-4 pt-0 xs:pt-2 flex-1 overflow-y-auto ">
        <!-- 🔍 Search input -->
        <div class="relative mb-2">
            <input
              v-model="search"
              type="text"
              :placeholder="$t('common.sidebar.search')" 
              class="w-full rounded-lg border border-white/20 bg-white/10 text-white placeholder-white/50 pl-3 pr-9 py-2 focus:outline-none focus:ring-1 focus:ring-blue-400"
            />
            <Search class="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/70" />
            <!-- Clear button -->
            <UButton
              v-if="search"
              icon="i-lucide-x"
              variant="subtle"
              @click="search = '';"
              :title="$t('common.tooltip.clear')"
              class="three-ac-button add absolute cursor-pointer right-8 top-1/2 -translate-y-1/2 text-red-500"
            />
        </div>
        <UNavigationMenu 
          :items="filteredItems"
          orientation="vertical"
          class="data-[orientation=vertical] text-white"
          :ui="{
            childList: 'w-full',
            childLinkDescription: 'text-balance line-clamp-2'
          }"
        >
        </UNavigationMenu>
      </div>
      <!-- Footer -->
      <div class=" items-center justify-between  px-3 pb-2 hidden sm:block">
        <div class="p-4 pb-8 flex items-center justify-center w-full">
            <button @click="logout" class="bg-3a-nav-btn flex flex-col items-center justify-center text-white hover:text-gray-200 transition">
                <UIcon name="i-lucide-log-out" class="h-6 w-6 mb-1" />
                <span class="text-sm">{{$t('common.sidebar.logout') }}</span>
            </button>
        </div>
        <div class="p-0 flex-shrink-0 mb-0">
            <div class="flex flex-row items-center justify-between w-full text-white hover:text-gray-200 transition text-xs">
                <SimplerLanguageSwitcher />
                <timezoneSwitcher />
            </div>
        </div> 
      </div>
      <div class="flex items-center justify-between px-3 pb-2 block sm:hidden">
        <div class="flex-shrink-0">
          <UButton @click="logout" class="bg-3a-nav-btn flex  items-center justify-center w-full text-white hover:text-gray-200 transition">
              <LogOut class="h-4 w-4 mr-2" style="margin-top:2px" />
              <span class="text-sm">{{$t('common.sidebar.logout') }}</span>
          </UButton>
        </div>
        <div class="p-0 flex-shrink-0 mb-0">
          <div class="flex flex-col items-center justify-center w-full text-white hover:text-gray-200 transition text-xs">
              <languageSwitcher />
          </div>
        </div>
        <div class="p-0 flex-shrink-0 mb-0">
          <div class="flex flex-col items-center justify-center w-full text-white hover:text-gray-200 transition text-xs">
              <timezoneSwitcher />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { NavigationMenuItem } from '@nuxt/ui';
import { useAttrs } from 'vue'
import LogoIcon from '~/assets/3a-logo-core-materials.svg'
import { ref } from 'vue';
import { useAuthStore } from '~/stores/auth'
import { X, LogOut, Search, Menu } from 'lucide-vue-next'

const { t, locale } = useI18n()

const router = useRouter()
const open = ref(false) 
const childRef = ref();
const { hasPermission } = usePermissions();

const props = defineProps<{
  menuStyle?: string,
  navbarStyle?: string
}>();

const { menuStyle, navbarStyle } = props

interface TreeNode {
  label: string
  key: string
  children?: TreeNode[]
}

const search = ref('')
// computed reactivo para el resultado

const userData = useAuthStore()

const userMenu = ref<NavigationMenuItem[]>([]);

const isMobileMenuOpen = ref(false);
const nombreUsuario = userData.user.firstName + " " + userData.user.lastName || 'usuario';
const email = userData.user.email || '';
const toggleMobileMenu = () => {
    isMobileMenuOpen.value = !isMobileMenuOpen.value;
};

const isTouchDevice = ref(null)
onMounted(() => {  
  ////verificar si es dispostivo tactil
  isTouchDevice.value =
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0;

  document.body.classList.toggle('touch-device', isTouchDevice.value);
});

onBeforeUnmount(() => {
})
 
const isFullscreen = ref(false)


const emit = defineEmits<{
  (e: 'select', item: NavigationMenuItem): void
}>()

async function logout(){
  useAuthStore().logout() //todo:customer
  await nextTick();
  navigateTo('/customers') // or use `useRouter().push('/customers')`
}
const getColSpan = (i: number) => {
  // indexes 0 and 1 span full width (1 column), rest span half width (2 per row)
  switch(i){
    case 0 : case 1 : case 3 :  return 'col-span-1';
    case 2 : return 'col-span-1';
    default: return 'col-span-1';
    
  } 
};
const getColWidth = (i: number) => {
  // indexes 0 and 1 span full width (1 column), rest span half width (2 per row)
  switch(i){
    case 0 : case 1 : case 3 :  return '600';
    case 2 : return '600';
    default: return '600';
    
  } 
};

let breadcrumbObserver: IntersectionObserver | null = null;

</script>
<style >
.menux {
 scrollbar-width: thin;
 scrollbar-color: #7283a1 #f3f4f600;
}
.menux::-webkit-scrollbar {
  width: 6px;
}
.menux::-webkit-scrollbar-track {
  background: #f3f4f6;
}
.menux::-webkit-scrollbar-thumb {
  background-color: #9ca3af;
  border-radius: 9999px;
}
nav > ul > li > a.text-muted,
nav > ul > li > button.text-muted,
nav > ul > li > button > span {
  color: white !important;
}

nav > div > ul > li > a.text-muted,
nav > div > ul > li > button.text-muted,
nav > div > ul > li > button > span {
  color: white !important;
}

div.vertical-navbar-items > nav > ul > li > div > ul > li > a.text-muted,
div.vertical-navbar-items > nav > ul > li > div > ul > li > a.text-muted,
div.vertical-navbar-items > nav > ul > li > div > ul > li > button.text-muted,
div.vertical-navbar-items > nav > ul > li > div > ul > li > button > span ,
div.vertical-navbar-items > nav > ul > li > div > ul > li > button > a > span,
nav > ul > li > a > span.iconify,
nav > ul > li > div > ul > li > a > span{
  color: white !important;
}

nav > ul > li > a.text-primary>span.iconify,
nav > ul > li > a.text-primary>span>span.iconify,
nav > ul > li > div > ul > li > a.text-primary>span.iconify  {
    color: rgba(0, 119, 188, 1) !important;
}

nav > ul > li > div > ul > li  {
    padding-right: 20px;
}
nav > ul > li > a.text-primary>span.truncate,
nav > ul > li > div > ul > li > a.text-primary>span.truncate  {
    background: linear-gradient(180deg,rgba(0, 119, 188, 1) 0%, rgba(38, 39, 114, 1) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent; /* fallback */
}

div.vertical-navbar-items > nav > ul > li > div > ul > li > a > span.iconify  {
  color: white !important;
}

div.vertical-navbar-items a.text-primary {
  width: 90% ;
}
div.vertical-navbar-items a.text-primary>span.truncate {
  background: linear-gradient(180deg,rgba(0, 119, 188, 1) 0%, rgba(38, 39, 114, 1) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent; /* fallback */
}

div.vertical-navbar-items a.text-primary>span.iconify  {
    color: rgba(38, 39, 114, 1) !important;
}

nav > div > ul > li > a.text-primary>span.iconify  {
    color: rgba(38, 39, 114, 1) !important;
}


nav > div > ul > li > a > span.i-lucide\:home {
  background-color: white !important;
}
nav > div > div > div > ul > li > a > span {
  margin-top:3px /* alínea los iconos en los submenús */
}
nav > div > ul > li > a > span {
  color: white !important;
}
nav > div > ul > li > a.text-primary {
  background: linear-gradient(180deg,rgba(0, 119, 188, 1) 0%, rgba(38, 39, 114, 1) 68%);-webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;  /*fallback */
}
nav > div > ul > li > a.text-primary > span.i-lucide\:home {
  background-color: rgba(38, 39, 114, 1) !important;
}
nav.navbar > div > ul > li > a.text-primary > span.iconify,
nav.navbar > div > ul > li > a.text-primary > span,
nav.navbar > div >div >div > ul > li > a > span,
nav.navbar > div >div >div > ul > li > a,
nav.navbar > div >div >div > ul > li > button > span  {
    color: rgba(38, 39, 114, 1);
}
.main-container {
  display: flex;
  justify-content: right !important; /* default */
}
.pseudo-navbar-option{
  cursor:pointer;
  background-color:transparent ;
  font-size:14px;
  font-weight:500;
  display:flex;
  vertical-align:center;
  padding:5px 5px 5px 8px;
  min-width:40px;
  white-space: nowrap;
}
.pseudo-navbar-option:hover{
  background-color:#ffffff75;
  padding:6px 5px 6px 8px;
  border-radius:5px;
}
</style>